import { Button, Typography } from '@mui/material';
import {
  AuthentificationState,
  useAmplifyServiceContext,
  useTranslation,
} from '@scorenco/core';

import { T_KEYS } from '@/translations';

const AuthentificationSignedOut = () => {
  const { t } = useTranslation();
  const { changeState } = useAmplifyServiceContext();

  return (
    <>
      <Typography variant="h2" mb={3} textAlign="left">
        {t(T_KEYS.AUTHENTIFICATION_SIGNED_OUT_WELCOME_TEXT)}
      </Typography>

      <Typography textAlign="left" mb={3}>
        {t(T_KEYS.AUTHENTIFICATION_SIGNED_OUT_DESCRIPTION)}
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        fullWidth
        onClick={() => {
          changeState({
            authState: AuthentificationState.SelectSport,
          });
        }}
        sx={{ width: '100%', mb: 2 }}
      >
        {t(T_KEYS.AUTHENTIFICATION_SIGN_UP_CTA)}
      </Button>

      <Button
        variant="text"
        color="primary"
        onClick={() => {
          changeState({
            authState: AuthentificationState.SignIn,
          });
        }}
        sx={{ width: '100%' }}
      >
        {t(T_KEYS.AUTHENTIFICATION_SIGN_IN_CTA)}
      </Button>
    </>
  );
};

export default AuthentificationSignedOut;
